export default "__VITE_ASSET__g$ogLr4I__"